<!-- Breadcrumb -->
<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
  <h5 class="mb-0">
    Plants List
  </h5>
  <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
    <li class="breadcrumb-item position-relative">
      Plants
    </li>
    <li class="breadcrumb-item position-relative">
      Plants List
    </li>
  </ol>
</div>
<mat-card class="daxa-card users-card ai-hero mb-25 border-radius bg-white border-none d-block">
  <section class="search-hero">
    <div class="search-wrap">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Owner name</mat-label>
        <input matInput [formControl]="ownerCtrl" placeholder="Type owner name…" (keyup.enter)="submit()" />
        <button mat-icon-button matSuffix type="button" aria-label="Search" (click)="submit()"
          [disabled]="!ownerCtrl.value?.trim()">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    </div>
  </section>
  <img class="image-btn" src="/images/projects/plant-list-image.png" alt="">
</mat-card>